/** What the backend accepts as a permanent password. */
export const PASSWORD_MIN_LENGTH = 12;

export const getPasswordChecks = (password: string) => ({
	isValidLength: password.length >= PASSWORD_MIN_LENGTH,
	hasUpperCase: /[A-Z]/.test(password),
	hasLowerCase: /[a-z]/.test(password),
	hasNumbers: /\d/.test(password),
	hasSpecialChar: /[@$!%*?&]/.test(password),
});

export const isStrongPassword = (password: string) =>
	Object.values(getPasswordChecks(password)).every(Boolean);
